import { getInstance, I18nDefinitions } from "@purecloud/ts-i18n";
import { useMemo } from "react";
import { useLocale } from "./useLocale";
import { renderString } from "i18n";
export function useRenderString() {
    const locale = useLocale();
    return useMemo(() => {
        return function (
            i18nKey: LocalizationKey,
            data?: Record<string, unknown>
        ) {
            return renderString(locale, i18nKey, data);
        };
    }, [locale]);
}
export function useI18nDriver() {
    const translate = useRenderString();
    return useMemo(() => {
        return getInstance({
            translate,
        });
    }, [translate]);
}
export function useStrings<Def extends I18nDefinitions>(strings: Def) {
    const driver = useI18nDriver();
    return useMemo(() => driver.buildTranslations(strings), [driver, strings]);
}
